import type { Dict } from './en';

export const de: Dict = {
  subtitle: 'Errate das Land des Tages',
  modes: { classic: 'Klassisch', flag: 'Flagge', outline: 'Umriss', connections: 'Verbindungen', trivia: 'Quiz', draw: 'Zeichnen' },
  recommendations: {
    title: 'Das könnte dir auch gefallen',
    open: '{name} öffnen',
    games: {
      wormillion: 'Tägliches Geografiespiel mit seltenen Antworten',
      stardewdle: 'Tägliche Rätsel in der Welt von Stardew Valley',
      cascadle: 'Tägliches Wortspiel mit wachsenden Wörtern',
      farhike: 'Tägliches Kartenquiz mit selten genannten Ländern',
    },
  },
  draw: {
    subtitle: 'Zeichne den Umriss aus dem Gedächtnis',
    askLabel: 'Zeichne dieses Land',
    drawingLabel: 'Zeichnet',
    askHint: 'Aus dem Gedächtnis — keine Vorlage, ein Versuch.',
    blank: 'ein leeres Blatt — kein Nachzeichnen',
    canvasLabel: 'Zeichenfläche',
    start: 'Zeichnen starten',
    undo: 'Rückgängig',
    clear: 'Löschen',
    done: 'Fertig',
    next: 'Nächstes Land',
    score: 'Punkte',
    accuracy: 'Genauigkeit',
    coverage: 'Abdeckung',
    deviation: 'Abweichung',
    legendTrue: 'Echter Umriss',
    legendYours: 'Deine Linie',
    legendOut: 'Zu weit außen',
    legendIn: 'Zu weit innen',
    pts: 'Pkt',
    learnMore: 'Mehr erfahren',
    ranks: [
      'Königlicher Kartograf',
      'Meisterkartograf',
      'Guter Landvermesser',
      'Ruhige Hand',
      'Lehrling',
      'Grobe Skizze',
      'Zurück zum Atlas',
    ],
  },
  trivia: {
    subtitle: 'Zehn Geografiefragen pro Tag',
    loading: 'Heutige Fragen werden geladen…',
    question: 'Frage',
    correct: 'Richtig!',
    wrong: 'Knapp daneben',
    next: 'Nächste Frage',
    seeResult: 'Ergebnis ansehen',
    xpNote: '3 XP pro richtiger Antwort, +10 bei zehn von zehn.',
    comeBack: 'Zehn neue Fragen um Mitternacht UTC.',
    tiers: ['Makellos — 10 von 10!', 'Stark gespielt.', 'Nicht schlecht. Bis morgen.', 'Zäher Tag. Die Welt ist groß.'],
  },
  conn: {
    subtitle: 'Sortiere 16 Länder in 4 Gruppen',
    oneAway: 'Fast!',
    shuffle: 'Mischen',
    deselect: 'Abwählen',
    submit: 'Senden',
    mistakes: 'Fehler',
    solved: 'Gelöst!',
    lost: 'Nächstes Mal!',
    nextPuzzle: 'Nächstes',
    flawless: 'Makellos — keine Fehler!',
    wellPlayed: 'Gut sortiert!',
    lostSub: 'Die vier Gruppen sind oben aufgedeckt.',
    guesses: 'Versuche',
  },
  soon: 'bald',
  streak: 'Serie',
  today: 'Heute',
  yesterday: 'Gestern',
  nextIn: 'Nächstes Land in',
  daily: 'Täglich',
  unlimited: 'Unlimited',
  nextCountry: 'Nächstes Land',
  skip: 'Überspringen',
  solved: 'Gelöst',
  best: 'Bestwert',
  emptyHint: 'Mach deinen ersten Tipp, um die Hinweise aufzudecken.',
  boardScrollLabel: 'Vergleichstabelle der Versuche. Horizontal scrollen, um alle Hinweise zu sehen.',
  legend: { correct: 'Treffer', incorrect: 'Kein Treffer', numbers: 'Lösung ↑ höher · ↓ niedriger', distance: 'näher → weiter' },
  placeholder: 'Land eingeben…',
  guess: 'Raten',
  won: 'Gelöst!',
  lost: 'Keine Versuche mehr',
  answerWas: 'Das Land war',
  answerCard: { viewProfile: 'Länderprofil', northernHemisphere: 'Nordhalbkugel', southernHemisphere: 'Südhalbkugel' },
  share: 'Teilen',
  copyLink: 'Link kopieren',
  copyResult: 'Ergebnis kopieren',
  copyEmbed: 'Einbettung kopieren',
  saveImage: 'Bild speichern',
  shareToday: 'Heute teilen',
  copied: 'Kopiert!',
  cols: { region: 'Region', pop: 'Bev.', area: 'Fläche', borders: 'Nachbarn', gdp: 'BIP', temp: 'Temp.', dist: 'Distanz' },
  colTips: {
    region: "Auf welchem Kontinent das Land liegt. Grün bedeutet derselbe Kontinent wie die Lösung.",
    dist: "Luftlinie zwischen deinem Tipp und der Lösung. Rot ist weit, Grün ist nah; der Pfeil zeigt zur Lösung.",
    borders: "Mit wie vielen Ländern es eine Landgrenze teilt. ↑ bedeutet, die Lösung hat mehr.",
    temp: "Jahresdurchschnittstemperatur 1991–2020, gemittelt über das gesamte Land — nicht die Hauptstadt.",
    pop: "Gesamtbevölkerung. ↑ bedeutet, die Lösung hat mehr Einwohner.",
    area: "Landfläche in km². ↑ bedeutet, die Lösung ist größer.",
    gdp: "BIP pro Kopf in US-Dollar. ↑ bedeutet, die Lösung ist pro Kopf reicher.",
  },
  puzzle: {
    flag: 'Zu welchem Land gehört diese Flagge?',
    outline: 'Welches Land hat diese Form?',
  },
  account: {
    signIn: 'Anmelden',
    withGoogle: 'Weiter mit Google',
    withDiscord: 'Weiter mit Discord',
    tagline: 'Speichere deine Serie geräteübergreifend',
    signOut: 'Abmelden',
    level: 'Stufe',
    viewProfile: 'Profil ansehen',
    editProfile: 'Profil bearbeiten',
  },
  settings: {
    title: 'Profil bearbeiten',
    avatar: 'Avatar',
    change: 'Ändern',
    displayName: 'Anzeigename',
    bio: 'Bio',
    bioPh: 'Erzähl den Entdeckern von dir…',
    birthday: 'Geburtstag',
    country: 'Land',
    countryNone: 'Nicht gesetzt',
    gender: 'Geschlecht',
    genders: { male: 'Männlich', female: 'Weiblich', other: 'Divers', na: 'Keine Angabe' },
    socials: 'Soziale Links',
    invalidUrl: 'Gib eine gültige URL für diese Plattform ein.',
    date: { year: 'Jahr', month: 'Monat', day: 'Tag' },
    save: 'Speichern',
    saving: 'Speichern…',
    saved: 'Gespeichert',
    signInRequired: 'Melde dich an, um dein Profil zu bearbeiten.',
    cropTitle: 'Avatar zuschneiden',
    cropHint: 'Ziehen zum Verschieben · scrollen zum Zoomen',
    apply: 'Übernehmen',
    cancel: 'Abbrechen',
    pick: 'Bild wählen',
    uploadError: 'Upload fehlgeschlagen — kleineres Bild versuchen.',
  },
  netError: 'Netzwerkfehler — bitte erneut versuchen.',
  offlinePractice: 'Offline-Übung — nicht gewertet.',
  xp: 'XP',
  levelUp: 'Levelaufstieg!',
  honors: {
    title: 'Abzeichen & Medaillen',
    intro: 'Jedes gelöste Rätsel wird dreifach festgehalten — ein Rang, den du trägst, eine Medaille, die du gewinnst, und ein Abzeichen, das du verteidigst.',
    levelT: 'Stufenabzeichen',
    levelD: 'XP aus dem täglichen Spiel trägt dich durch 14 gravierte Gefährte der Reise — vom Wanderstab bis zum weltumsegelnden Flaggschiff.',
    dailyT: 'Tagesmedaillen',
    dailyD: 'Die Heute-Bestenliste ordnet alle Entdecker danach, wie viele der sechs Modi sie schaffen, und dann nach der Zahl der Versuche. Die besten drei holen Gold, Silber und Bronze — dauerhaft auf deinem Profil gezählt.',
    boardT: 'Ranglisten-Abzeichen',
    boardD: 'Halte einen Podestplatz auf der Serien-, Endlos- oder Level-Rangliste, und jeder Tag wird ins Abzeichen graviert. Gold-, Silber- und Bronzetage werden getrennt gezählt.',
    cta: 'Zur Bestenliste',
  },
  lb: {
    scoreBreakdown: "Punkte im Detail",
    scoreAvg: "Durchschnitt",
    scoreNote: "Sortiert zuerst nach abgeschlossenen Modi, dann nach diesem Durchschnitt.",
    title: 'Bestenliste',
    today: 'Heute',
    streak: 'Serie',
    level: 'Level',
    unlimited: 'Endlos',
    connections: 'Verbindungen',
    myRank: 'Dein Rang',
    empty: 'Noch keine Einträge — sei der Erste.',
    signInToRank: 'Melde dich an, um in der Bestenliste zu erscheinen.',
    guesses: 'Versuche',
    guess1: 'Versuch',
    totalSolved: 'Gelöst',
    yourStats: 'Deine Statistik',
    back: 'Zurück zum Spiel',
    nav: 'Bestenliste',
    viewAll: 'Alle ansehen',
    dailyMedals: 'Tagesmedaillen',
    heldBadges: 'Ranglisten-Abzeichen',
    notFound: 'Entdecker nicht gefunden.',
  },
  privacy: {
    title: 'Datenschutzerklärung',
    updated: 'Zuletzt aktualisiert: 28. Juni 2026',
    sections: [
      {
        h: 'Wer wir sind',
        p: ['GeoDle („wir") ist ein kostenloses tägliches Länder-Ratespiel, verfügbar auf geodle.org.'],
      },
      {
        h: 'Was wir erheben',
        p: [
          'Spieldaten: deine Versuche, deinen Tagesfortschritt, deine Serie und Erfahrungspunkte — um das Spiel zu betreiben und geräteübergreifend zu synchronisieren.',
          'Kontodaten (nur wenn du dich mit Google oder Discord anmeldest): eine eindeutige Konto-ID, deinen Anzeigenamen und dein Avatarbild. Dein Passwort erhalten wir nie.',
        ],
      },
      {
        h: 'Wie wir deine Daten nutzen',
        p: [
          'Um deinen Fortschritt zu speichern und zu synchronisieren, Serien und Level zu berechnen und öffentliche Bestenlisten und Profile für angemeldete Spieler anzuzeigen.',
          'Wir verkaufen deine Daten nicht und nutzen sie nicht für Werbung.',
        ],
      },
      {
        h: 'Analyse & Cookies',
        p: [
          'Wir nutzen Google Analytics und Microsoft Clarity, um anonyme, aggregierte Nutzung zu verstehen. Diese Dienste können eigene Cookies setzen; wir nutzen sie nicht, um dich persönlich zu identifizieren.',
          'Wir verwenden ein eigenes Cookie, um dich angemeldet zu halten und deinen Fortschritt zu synchronisieren.',
        ],
      },
      {
        h: 'Deine Rechte & Löschung',
        p: [
          'Du kannst dein Konto und alle zugehörigen Daten jederzeit über die Schaltfläche unten dauerhaft löschen. Die Löschung wirkt sofort.',
        ],
      },
      { h: 'Kontakt', p: ['Fragen zu deinen Daten? Schreib an contact@geodle.org.'] },
    ],
    deleteAccount: 'Mein Konto & Daten löschen',
    deleteConfirm: 'Dies löscht dein Konto und allen Fortschritt dauerhaft. Fortfahren?',
    deleted: 'Dein Konto und deine Daten wurden gelöscht.',
  },
  terms: {
    title: 'Nutzungsbedingungen',
    updated: 'Zuletzt aktualisiert: 28. Juni 2026',
    sections: [
      {
        h: 'Annahme',
        p: ['Mit der Nutzung von GeoDle akzeptierst du diese Bedingungen. Wenn du nicht einverstanden bist, nutze den Dienst bitte nicht.'],
      },
      {
        h: 'Der Dienst',
        p: [
          'GeoDle ist ein kostenloses tägliches Ratespiel, bereitgestellt „wie besehen", zur persönlichen, nicht-kommerziellen Unterhaltung. Wir können jeden Teil jederzeit ändern, aussetzen oder einstellen.',
        ],
      },
      {
        h: 'Konten & Fairplay',
        p: [
          'Die Anmeldung ist optional und dient dazu, deinen Fortschritt zu synchronisieren und dich einzustufen. Du bist für die Aktivität deines Kontos verantwortlich.',
          'Betrüge nicht, automatisiere das Spiel nicht und manipuliere keine Punkte, Serien oder Bestenlisten. Wir können solche Einträge oder Konten entfernen.',
        ],
      },
      {
        h: 'Akzeptable Nutzung',
        p: [
          'Wähle einen Anzeigenamen und ein Avatar, die nicht beleidigend, rechtsverletzend oder irreführend sind. Wir können verstoßende Inhalte oder Konten entfernen.',
        ],
      },
      {
        h: 'Geistiges Eigentum',
        p: [
          'Länderdaten stammen aus offenen Datensätzen (mledoze/countries, Natural Earth). GeoDle ist ein unabhängiges Projekt ohne Verbindung zu einer Regierung oder Organisation.',
        ],
      },
      {
        h: 'Haftungsausschluss',
        p: [
          'Der Dienst wird ohne jegliche Gewährleistung bereitgestellt. Soweit gesetzlich zulässig, haften wir nicht für Schäden aus deiner Nutzung von GeoDle.',
        ],
      },
      {
        h: 'Änderungen',
        p: ['Wir können diese Bedingungen gelegentlich aktualisieren. Die weitere Nutzung nach einer Änderung gilt als Annahme der aktualisierten Bedingungen.'],
      },
      { h: 'Kontakt', p: ['Fragen? Schreib an contact@geodle.org.'] },
    ],
  },
  country: {
    whereOnEarth: 'Wo auf der Erde',
    atAGlance: 'Auf einen Blick',
    howItCompares: 'Im Vergleich',
    neighbours: 'Nachbarländer',
    inGeoDle: '{name} in GeoDle',
    exploreNearby: 'In der Nähe',
    faqTitle: 'FAQ',
    metaTitle: '{name} — Hauptstadt, Bevölkerung, Fläche & Fakten | GeoDle',
    metaDesc: '{name}: Hauptstadt {capital}, Bevölkerung {pop}, Fläche {area} km². Das {rankPop} bevölkerungsreichste Land, in {region}. Fakten, Karte, Nachbarn und mehr.',
    getToKnow: '{name} kennenlernen',
    k: { history: 'Historische Momente', people: 'Berühmte Persönlichkeiten', landmarks: 'Sehenswürdigkeiten', culture: 'Kultur & Genuss' },
    sources: 'Quellen',
    listTitle: 'Länder',
    listSearch: 'Land suchen…',
    listAll: 'Alle Regionen',
    listCount: '{n} Länder',
    listEmpty: 'Keine Länder entsprechen deiner Suche.',
    promoTitle: 'Alle Länder entdecken',
    promoDesc: 'Flaggen, Hauptstädte, Bevölkerung und ein interaktiver Globus – eine ausführliche Seite für alle 194 Länder.',
    promoCta: 'Länder durchsuchen',
    metaTitleList: 'Alle Länder der Welt — Flaggen, Hauptstädte & Fakten | GeoDle',
    metaDescList: 'Durchstöbere alle Länder: Flaggen, Hauptstädte, Bevölkerung, Fläche und mehr. Suche und filtere nach Region und erkunde die Welt auf einem interaktiven Globus.',
    play: 'Spielen',
    guessFlag: 'Flagge erraten',
    guessOutline: 'Umriss erraten',
    back: 'GeoDle',
    notFound: 'Land nicht gefunden.',
    landlocked: 'Binnenland',
    coastal: 'Küstenland',
    north: 'Norden',
    south: 'Süden',
    landBorders: '{n} Landesgrenzen',
    landBorder: '1 Landesgrenze',
    noBorders: '{name} hat keine Landgrenzen.',
    locLede: '{name} liegt in {subregion}, {region}.',
    locLandlocked: 'Es ist ein Binnenland ohne Meeresküste.',
    locCoastal: 'Es hat eine Meeresküste.',
    locBorders: 'Es grenzt an {n} Länder.',
    locBorder: 'Es grenzt an ein Land.',
    locIsland: 'Als Inselstaat hat es keine Landgrenzen.',
    f: { capital: 'Hauptstadt', population: 'Bevölkerung', area: 'Fläche', region: 'Region', subregion: 'Subregion', coast: 'Küste', hemisphere: 'Hemisphäre', iso: 'ISO', languages: 'Sprachen', currency: 'Währung', timezone: 'Zeitzone', calling: 'Vorwahl', driving: 'Verkehr', tld: 'Domain', nativeName: 'Einheimischer Name' },
    s: {
      popWorld: 'bevölkerungsreichstes Land der Welt (von {total}).',
      popRegion: 'bevölkerungsreichstes in {region} (von {total}).',
      areaLargest: 'größtes nach Fläche',
      biggerThan: 'größer als {x}',
      smallerThan: 'kleiner als {x}',
      perKm2: 'Einwohner pro km²',
      sparse: 'dünn besiedelt',
      moderate: 'mäßig dicht',
      dense: 'dicht besiedelt',
      morePeople: 'mehr Einwohner als {x}',
      fewerPeople: 'weniger als {x}',
      vs: 'vs',
      neighbours: 'Landnachbarn',
      neighbour: 'Landnachbar',
    },
    q: {
      capitalQ: 'Was ist die Hauptstadt von {name}?',
      capitalA: 'Die Hauptstadt von {name} ist {capital}.',
      popQ: 'Wie viele Einwohner hat {name}?',
      popA: '{name} hat etwa {pop} Einwohner — das {rank} bevölkerungsreichste Land der Welt.',
      areaQ: 'Wie groß ist {name}?',
      areaA: '{name} umfasst {area} km² und ist damit das {rank} größte Land nach Fläche.',
      regionQ: 'In welcher Region liegt {name}?',
      regionA: '{name} liegt in {subregion}, {region}.',
    },
  },
  footer:
    'Länderdaten: mledoze/countries (ODbL) · Kartendaten: Natural Earth (gemeinfrei). GeoDle ist ein unabhängiges Projekt, ohne Verbindung zu Regierungen oder Organisationen.',
};
